import React from 'react';
import { Link } from 'react-router-dom';
import { Subscribe, appContainer } from '../../../../contexts/app';

// NOTE: This component must be a class bc material-ui
// barks at it being used in containerElement props
// about stateless funcs using refs? Weird.
export default class SidebarLink extends React.Component {
  render() {
    return (
      <Subscribe
        to={[appContainer]}
        render={app => {
          const windowWidth = app.state.get('windowWidth');
          const shouldClose = windowWidth <= 700;
          return (
            <Link
              {...this.props}
              onClick={shouldClose ? () => app.set('sidebarOpen', false) : null}
            >
              {[this.props.children]}
            </Link>
          );
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/SidebarLink/index.jsx